import { render, staticRenderFns } from "./barImg.vue?vue&type=template&id=0d70e92e&scoped=true"
import script from "./barImg.vue?vue&type=script&lang=js"
export * from "./barImg.vue?vue&type=script&lang=js"
import style0 from "./barImg.vue?vue&type=style&index=0&id=0d70e92e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70e92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d70e92e')) {
      api.createRecord('0d70e92e', component.options)
    } else {
      api.reload('0d70e92e', component.options)
    }
    module.hot.accept("./barImg.vue?vue&type=template&id=0d70e92e&scoped=true", function () {
      api.rerender('0d70e92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/hubInventoryBoard/barImg.vue"
export default component.exports